import { ProviderType } from 'features/connections'
import settings from 'settings'

const { documentationUrl, cartoAcademyUrl } = settings

export const MARKDOWN_GUIDE = 'https://www.markdownguide.org/basic-syntax/'
export const DOCS_CONNECTIONS = `${documentationUrl}/carto-user-manual/connections`
export const DOCS_WORKFLOWS = '/carto-user-manual/workflows/components'
export const DOCS_ENRICHING_DATA = '/carto-user-manual/data-explorer/enriching-data'
export const DOCS_CREATING_TILESET = '/carto-user-manual/data-explorer/creating-a-tileset-from-your-data'
export const DOCS_CUSTOM_EXPRESSIONS = '/carto-user-manual/workflows/scheduling-workflows#custom-expressions'
export const DOCS_IMPORT_WORKFLOW =
  'https://docs.carto.com/carto-user-manual/workflows/sharing-workflows#import-a-workflow-from-a-sql-file'
export const DOCS_TEMP_DATA_IN_WORKFLOWS = '/carto-user-manual/workflows/temporary-data-in-workflows'
export const DOCS_WORKFLOW_VARIABLES = '/carto-user-manual/workflows/using-variables'
export const DOCS_WORKFLOW_EXECUTING_VIA_API = '/carto-user-manual/workflows/executing-a-workflow-via-api'
export const DOCS_WORKFLOWS_SCHEDULE_VERSION_INFO =
  '/carto-user-manual/workflows/scheduling-workflows#data-transfer-version-info'
export const DOCS_WORKFLOW_USE_CACHE = '/carto-user-manual/workflows/temporary-data-in-workflows#cache-options'
export const DOCS_GUEST_MODE = '/carto-user-manual/settings/users-and-groups/managing-user-roles#guest-viewers'
export const DOCS_IP_WHITELISTING = '/carto-user-manual/connections/ip-whitelisting'
export const DOCS_CARTO_AI = '/carto-user-manual/settings/carto-ai'
export const DOCS_CARTO_AI_CONFIGURATION =
  '/carto-self-hosted/guides/guides-helm/enable-agentic-gis-helm/configure-carto-ai-requirements'
export const DOCS_CARTO_AI_AGENTS = `${documentationUrl}/carto-user-manual/ai-agents`
export const DOCS_CARTO_AI_WORKING_WITH_TOOLS = `${documentationUrl}/carto-user-manual/ai-agents/working-with-tools`
// To be confirmed DOCS_CARTO_AI_AGENTS_VIDEO & DOCS_CARTO_AI_AGENTS_DOCUMENTATION
export const DOCS_CARTO_AI_AGENTS_VIDEO = `${documentationUrl}/carto-user-manual/ai-agents/video`
export const DOCS_CARTO_AI_AGENTS_ACADEMY = `${cartoAcademyUrl}/agentic-gis/ai-agents`
export const DOCS_CARTO_AI_TERMS =
  'https://drive.google.com/file/d/1QqidTLrDNqMbWg0D1RbHC3lkOSOHVXam/view?usp=drive_link'
export const DOCS_CARTO_MCP_SERVER = '/carto-mcp-server'

export const DOCS_WORKFLOWS_EXTENSION = 'https://docs.carto.com/carto-user-manual/workflows/extension-packages'
export const DOCS_SHARE_CONNECTION_VIEWER_CREDENTIALS =
  '/carto-user-manual/connections/sharing-a-connection#require-viewers-credentials'
export const DOCS_SHARING_WITH_CERTAIN_GROUPS =
  '/carto-user-manual/maps/publishing-and-sharing-maps/#sharing-with-certain-groups'
export const DOCS_MANAGING_USER_GROUPS = '/carto-user-manual/settings/users-and-groups/managing-user-groups'

export const DOCS_ANALYTICS_TOOLBOX = '/data-and-analysis/analytics-toolbox-overview'
export const DOCS_MANAGING_SUBSCRIPTIONS = '/data-and-analysis/data-observatory/guides/managing-your-subscriptions'
export const DATA_OBSERVATORY = '/data-and-analysis/data-observatory'
export const DOCS_AT_LOCATION = {
  [ProviderType.BIGQUERY]:
    '/data-and-analysis/analytics-toolbox-for-bigquery/getting-access#access-from-carto-workspace',
  [ProviderType.REDSHIFT]: '/data-and-analysis/analytics-toolbox-for-redshift/getting-access',
  [ProviderType.POSTGRES]: '/data-and-analysis/analytics-toolbox-for-postgresql/getting-access',
  [ProviderType.SNOWFLAKE]: '/data-and-analysis/analytics-toolbox-for-snowflake/getting-access',
  [ProviderType.DATABRICKS_WAREHOUSE]: '/data-and-analysis/analytics-toolbox-for-databricks/getting-access'
}
export const DOCS_WIF = '/carto-user-manual/settings/advanced-settings/workload-identity-federation'
export const DOCS_WIF_EXTERNAL = 'https://cloud.google.com/iam/docs/workload-identity-federation'
export const DOCS_BIGQUERY = '/carto-user-manual/connections/bigquery'
export const DOCS_DATABRICKS = '/carto-user-manual/connections/databricks'
export const DOCS_DATABRICKS_INTEGRATION =
  '/carto-user-manual/settings/advanced-settings/configuring-oauth-connections-to-databricks'
export const DOCS_DATABRICKS_EXTERNAL = 'https://docs.databricks.com/aws/en/dev-tools/auth/oauth-u2m'

export const DATA_OBSERVATORY_DOCS = '/carto-user-manual/data-observatory'

export const DATA_ANALYSIS_BIGQUERY = `${documentationUrl}/data-and-analysis/analytics-toolbox-for-bigquery/getting-access`
export const DATA_ANALYSIS_SNOWFLAKE = `${documentationUrl}/data-and-analysis/analytics-toolbox-for-snowflake/getting-access`
export const DATA_ANALYSIS_POSTGRES = `${documentationUrl}/data-and-analysis/analytics-toolbox-for-postgresql`
export const DATA_ANALYSIS_REDSHIFT = `${documentationUrl}/data-and-analysis/analytics-toolbox-for-redshift/getting-access`
export const DATA_ANALYSIS_OVERVIEW = `${documentationUrl}/data-and-analysis/analytics-toolbox-overview`

export const SETTINGS_BASEMAPS_URL_DOC = `/carto-user-manual/settings/customizations/configuring-your-organization-basemaps#custom-basemaps`

export const INSTALLATION_DOCS_BIGQUERY = `${documentationUrl}/data-and-analysis/analytics-toolbox-for-bigquery`
export const INSTALLATION_DOCS_SNOWFLAKE = `${documentationUrl}/analytics-toolbox-snowflake/overview/getting-access/#manual-installation-for-carto-customers`
export const INSTALLATION_DOCS_DATABRICKS = `${documentationUrl}/analytics-toolbox-databricks/overview/installation/`
export const INSTALLATION_DOCS_REDSHIFT = `${documentationUrl}/analytics-toolbox-redshift/overview/getting-access/#getting-access`
export const INSTALLATION_DOCS_POSTGRES = `${documentationUrl}/analytics-toolbox-postgres/overview/getting-started/`

export const ANALYTICS_TOOLBOX_BIGQUERY = `${documentationUrl}/data-and-analysis/analytics-toolbox-for-bigquery`
export const ANALYTICS_TOOLBOX_SNOWFLAKE = `${documentationUrl}/data-and-analysis/analytics-toolbox-for-snowflake`
export const ANALYTICS_TOOLBOX_POSTGRES = `${documentationUrl}/data-and-analysis/analytics-toolbox-for-postgresql`
export const ANALYTICS_TOOLBOX_REDSHIFT = `${documentationUrl}/data-and-analysis/analytics-toolbox-for-redshift`
export const ANALYTICS_TOOLBOX_DATABRICKS = `${documentationUrl}/data-and-analysis/analytics-toolbox-for-databricks`

export const BUILDER_APPLICATION_DEVELOPERS = '/carto-user-manual/maps/exporting-data'
export const BUILDER_EXPORT_LAYER = '/carto-user-manual/maps/exporting-data'
export const BUILDER_MAP_ID_DOCUMENTATION = '/carto-for-developers/carto-for-deck.gl/rapid-map-prototyping'
export const BUILDER_URL_PARAMETERS = '/carto-user-manual/maps/publishing-and-sharing-maps/url-parameters'
export const BUILDER_FRESHNESS_DOC = '/carto-user-manual/maps/data-sources/managing-data-freshness'
export const BUILDER_EMBEDDING_DOC = '/carto-user-manual/maps/publishing-and-sharing-maps/embedding-maps'
export const BUILDER_DEFINING_SPATIAL_DATA = '/carto-user-manual/maps/data-sources/defining-source-spatial-data'

export const INTEGRATION_REDSHIFT_IMPORT =
  '/carto-user-manual/settings/advanced-settings/configuring-s3-bucket-for-redshift-imports'
export const INTEGRATION_RDS_POSTGRES_EXPORT =
  '/carto-user-manual/settings/advanced-settings/configuring-s3-bucket-integration-for-rds-for-postgresql-exports-in-builder'

export const DEVELOPERS_API_ACCESS_TOKEN = `${documentationUrl}/carto-for-developers/key-concepts/authentication-methods/api-access-tokens`
export const DEVELOPERS_SPA_CLIENT = `${documentationUrl}/carto-for-developers/key-concepts/authentication-methods/applications#single-page-application-spa`
export const DEVELOPERS_M2M_CLIENT = `${documentationUrl}/carto-for-developers/key-concepts/authentication-methods/applications#machine-to-machine-authentication-m2m`

export const DEVELOPERS_DOCS_OVERVIEW = `${documentationUrl}/carto-for-developers/overview`
export const DEVELOPERS_DOCS_KEY_CONCEPTS = `${documentationUrl}/carto-for-developers/key-concepts`
export const DEVELOPERS_DOCS_DECK = `${documentationUrl}/carto-for-developers/carto-for-deck.gl`

export const DEVELOPERS_GUIDES = `${documentationUrl}/carto-for-developers/guides`
export const DEVELOPERS_GUIDE_1 = `${documentationUrl}/carto-for-developers/guides/build-a-public-application`
export const DEVELOPERS_GUIDE_2 = `${documentationUrl}/carto-for-developers/guides/build-a-private-application-using-sso`
export const DEVELOPERS_GUIDE_3 = `${documentationUrl}/carto-for-developers/guides/integrate-carto-in-your-existing-application`
export const DEVELOPERS_WORKFLOWS_API_ENABLED = `${documentationUrl}/carto-user-manual/workflows/executing-workflows-via-api`

export const DEVELOPERS_NAMED_SOURCES_DOC = `${documentationUrl}/carto-user-manual/developers/named-sources`

export const DEVELOPERS_CREDENTIALS = `${documentationUrl}/carto-for-developers/key-concepts/authentication-methods`

export const SEARCH_LOCATION_DOC = `${documentationUrl}/carto-user-manual/maps/search-locations#focus-on-my-location-tool`

export const ACTIVITY_DATA_ACCESS_VIA_API_URL = `${documentationUrl}/carto-user-manual/settings/activity-data#access-via-api`
export const ACTIVITY_DATA_EXPORTS_DOC_PATH = `/carto-user-manual/settings/activity-data/`

export const SUBSCRIPTIONS_LIST = '/settings/data-observatory'
export const SETTINGS_USAGE = '/settings/usage'

export const DATA_CATALOG_CONTACT_FORM_URL = 'https://carto.com/contact/'
export const DATA_CATALOG_CONTACT_MAIL = 'mailto:data-sales@carto.com'
export const DATA_CATALOG_FOOTER_LINK =
  'https://research-and-innovation.ec.europa.eu/funding/funding-opportunities/funding-programmes-and-open-calls/horizon-2020_en'

export const PUBLIC_CATALOG_FORM_URL = 'https://carto.com/spatial-data-catalog/form'
export const PUBLIC_CATALOG_SIGNUP = 'http://app.carto.com/signup'

export const MAPBOX_RTL_TEXT_JS = '/assets/mapbox-gl-rtl-text.js'

export const DOCS_WORKFLOW_MCP_TOOL = '/carto-user-manual/workflows/workflows-as-mcp-tools'
